import { useTranslation } from 'react-i18next';

const LandingStats = () => {
  const { t } = useTranslation();
  const items = [
    { emoji: '📋', label: t('landing.statsChores') },
    { emoji: '👨‍👩‍👧‍👦', label: t('landing.statsFamilies') },
    { emoji: '⭐', label: t('landing.statsRating') },
  ];
  return (
    <section className="py-10 px-4 border-y border-border/40 bg-muted/20">
      <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-center">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-2 text-sm sm:text-base font-semibold text-foreground/80">
            <span aria-hidden className="text-xl">{it.emoji}</span>
            <span>{it.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LandingStats;
